/*
  Brand-switcher click handler. Listens for clicks on any element
  with [data-target-brand], updates the cart attribute + 7-day brand cookie
  backup, and navigates to that brand's home page.

  Targets:
    data-target-brand="cadenlane"      → / (clears attribute)
    data-target-brand="lane-and-leash" → /pages/lane-and-leash

  Loaded as a standalone <script defer> tag in layout/theme.liquid.
*/
(function() {
  'use strict';

  var DEST = {
    'cadenlane': '/',
    'lane-and-leash': '/pages/lane-and-leash'
  };

  function setBrand(brand) {
    var attrValue = brand === 'lane-and-leash' ? 'lane-and-leash' : '';
    var body = JSON.stringify({ attributes: { brand: attrValue } });

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body,
      credentials: 'same-origin'
    }).then(function() {
      try {
        if (attrValue) {
          document.cookie = 'brand=' + encodeURIComponent(attrValue) +
            '; path=/; max-age=604800; SameSite=Lax; Secure';
        } else {
          document.cookie = 'brand=; path=/; max-age=0; SameSite=Lax; Secure';
        }
      } catch (e) {}
    });
  }

  function onClick(event) {
    var target = event.target.closest('[data-target-brand]');
    if (!target) return;

    var brand = target.getAttribute('data-target-brand');
    if (!DEST.hasOwnProperty(brand)) return;

    event.preventDefault();

    // If user is already in that brand, do nothing.
    var serverBrand = document.documentElement.getAttribute('data-current-brand') || '';
    var normalized = brand === 'lane-and-leash' ? 'lane-and-leash' : '';
    if (normalized === serverBrand) return;

    // Fire the cart update and navigate. The current page stays visible
    // during the transition — the user initiated this click and expects
    // standard navigation behavior, not a blank page.
    setBrand(brand).then(function() {
      window.location.href = DEST[brand];
    }).catch(function() {
      // Even if the cart update request fails, navigate anyway. The head
      // script on the destination page handles brand reconciliation
      // (content detection, ?brand= param, cookie backup) so the brand
      // mode still flips on arrival.
      window.location.href = DEST[brand];
    });
  }

  document.addEventListener('click', onClick);
})();
